import { useEffect, useState } from "react";
import { EventType } from "@azure/msal-browser";
import AuthService, { ConnectionState } from "services/AuthService";
import { ThemeProvider } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";
import { tss } from "tss-react";
import Loader from "views/Loader";
import { config } from "config";
import pkg from "../package.json";
import { MsalProvider } from "@azure/msal-react";
import EventsEmitter from "events/EventsEmitter";
import { themeHandler } from "styles/theme";
import {Provider, useDispatch, useSelector } from "react-redux";
import store from "./store";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

//import { AppSnackbar } from 'themes/jumbo/app/_components/_core';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { CONFIG } from 'themes/jumbo/app/_config';
import 'themes/jumbo/app/_themes/assets/fonts/noir-pro/styles.css';
import 'themes/jumbo/app/_utilities/style/style.css';
import {
  JumboConfigProvider,
  //JumboDialog,
  JumboDialogProvider,
  JumboTheme,
} from 'themes/jumbo/@jumbo/components';
import { CssBaseline } from '@mui/material';
import {
	resetAuthData,
    getAuthData
} from "store/auth";

import { fetchAdditionalData } from "store/auth";
import { BrowserRouter as Router } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { trackPageView } from "components/Tracking";

const useStyles = tss.create(() => ({
    root: {
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        margin: 0,
    },
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto'
    }
}));

console.log("***Current App Version:", pkg.version);

export const fetchDataAndCheckState = () => async (dispatch:any, getState:any) => {
    await dispatch(getAuthData({
        key_id: 'e386cf6d8d4d2513c326a7bb0945b041',
        email: btoa(AuthService.userEmail)
    }));  // Dispatching an action (e.g., fetching data)

    const state =  store.getState();
    // Now you can use the updated state for further actions or logic
    if (state.auth.data.subscription_reference) {
        dispatch(fetchAdditionalData(state.auth.data.subscription_reference))
    }else{
        console.log("CALL Usage Data for free account")
        dispatch(fetchAdditionalData(btoa(AuthService.userEmail)))
    }
    
};


const AuthMonitoring = () => {
	const dispatch = useDispatch<any>();
   
    useEffect(() => {
        AuthService.connectionState !== 4 && dispatch(resetAuthData());
        AuthService.connectionState === 4 && dispatch(fetchDataAndCheckState());
        // AuthService.connectionState === 4 && dispatch(getAuthData({
        //     key_id: 'e386cf6d8d4d2513c326a7bb0945b041',
        //     email: btoa(AuthService.userEmail)
        // })) && dispatch(fetchAdditionalData('BR575HQZ2D'));
        
    }, [AuthService.connectionState])

    return <></>
}


export default function App(props: { pca: any }) {
    const location = useLocation();
    const { classes } = useStyles();
    let { pca } = props;
    const [state, setState] = useState(0);
    //const [compt, setCompt] = useState(0);

    if (pca.controller) {
        pca = pca.controller;
    }

    useEffect(() => {
        trackPageView(location.pathname + location.search);
    }, [location]);

    useEffect(() => {
        let sessionTimeoutTimer: any;
        const SESSION_TIMEOUT_MS = 60 * 60 * 1000; // Disconnect after 60 minutes of inactivity

        const startSessionTimer = () => {
            if (sessionTimeoutTimer) {
                clearTimeout(sessionTimeoutTimer);
            }
            sessionTimeoutTimer = setTimeout(() => {
                AuthService.logout(); // call with forceLogin = true if needed
            }, SESSION_TIMEOUT_MS);
        };

        const resetSessionTimer = () => {
            startSessionTimer();
        };

        // Start timer at app start
        startSessionTimer();

        // Listen to user activity
        document.addEventListener("mousemove", resetSessionTimer);
        document.addEventListener("keydown", resetSessionTimer);
        document.addEventListener("click", resetSessionTimer);

        // Cleanup when component unmounts
        return () => {
            console.log("Cleaning up session timer...");
            if (sessionTimeoutTimer) {
                clearTimeout(sessionTimeoutTimer);
            }
            document.removeEventListener("mousemove", resetSessionTimer);
            document.removeEventListener("keydown", resetSessionTimer);
            document.removeEventListener("click", resetSessionTimer);
        };
    }, []);


    // useEffect(() => {
    //     const interval = setInterval(() => {
    //     setCompt(prevCount => {
    //         console.log("Compteur : " + (prevCount + 1));
    //         return prevCount + 1;
    //     });
    //     }, 1000);

    //     // Cleanup function to clear the interval when component unmounts
    //     return () => clearInterval(interval);
    // }, []);

    useEffect(() => {

        const handleExpires = () => {
            AuthService.connectionState = ConnectionState.NEEDS_LOGIN;
            setState(AuthService.connectionState);
            AuthService.authenticate((state: number) => {
                setState(state);
            });
        };
        const handleMsaEvents = (event: any) => {
            console.log("msal.Event:", event);
            switch (event.eventType) {
                case EventType.SSO_SILENT_FAILURE:
                    AuthService.connectionState = ConnectionState.ERROR;
                    setState(AuthService.connectionState);
                    break;
                case EventType.SSO_SILENT_SUCCESS: {
                    AuthService.authenticate((state: number) => {
                        setState(state);
                    });
                    break;
                }
                case EventType.LOGIN_SUCCESS:
                    if (event.payload !== null && event.payload.account) {
                        const account = event.payload.account;
                        if (AuthService.clientApp) {
                            AuthService.connectionState = ConnectionState.CONNECTED;
                            AuthService.clientApp.setActiveAccount(account);
                        }
                    }
                    break;
                case EventType.ACQUIRE_TOKEN_FAILURE:
                    AuthService.connectionState = ConnectionState.NEEDS_LOGIN;
                    setState(AuthService.connectionState);
                    window.location.href = config.auth.authority + "";
                    break;
                case EventType.ACQUIRE_TOKEN_SUCCESS:
                    AuthService.connectionState = ConnectionState.CONNECTING;
                    setState(AuthService.connectionState);
                    break;
                case EventType.INITIALIZE_START:
                    AuthService.connectionState = ConnectionState.CONNECTING;
                    setState(AuthService.connectionState);
                    break;
                case EventType.HANDLE_REDIRECT_END:
                    if (AuthService.connectionState === ConnectionState.CONNECTING) {
                        setState(AuthService.connectionState);
                        AuthService.authenticate((state: number) => {
                            setState(state);
                        });
                    }
                    break;
                default:
                    break;
            }
        };
        if (pca.config.auth.clientId === "") {
            AuthService.needLogin = false;
            AuthService.connectionState = ConnectionState.CONNECTED;
            setState(ConnectionState.CONNECTED);
        } else {
                           
            pca.addEventCallback(handleMsaEvents);
            AuthService.needLogin = true;
            AuthService.setClientApp(pca);
            if (AuthService.connectionState === ConnectionState.IDLE) {
                AuthService.authenticate((state: number) => {
                    setState(state);
                });
            }
        }
        EventsEmitter.on("authExpires", handleExpires);
        return () => {
            if (pca && pca.removeEventCallback) {
                pca.removeEventCallback(handleMsaEvents);
                EventsEmitter.removeEventListener("authExpires", handleExpires);
            }
        };
    }, [pca]);

    return (
        <Provider store={store}>
            <Router basename={process.env.PUBLIC_URL}>
                <AuthMonitoring />
                <ReactNotifications />
                <JumboConfigProvider>
                    <JumboTheme init={CONFIG.THEME}>
                        <CssBaseline />
                        <JumboDialogProvider>
                            <>
                                {state === 0 ? (
                                    <CircularProgress className={classes.CircularProgress} />
                                ) : pca.config.auth.clientId === "" ? (
                                    <Loader />
                                ) : (
                                    <MsalProvider instance={pca}>
                                        <Loader />
                                    </MsalProvider>
                                )}
                            </>
                        </JumboDialogProvider>
                    </JumboTheme>
                </JumboConfigProvider>
                {/* </LocalizationProvider> */}
            </Router>
        </Provider>
    );
}
